import { render, staticRenderFns } from "./gift-present.vue?vue&type=template&id=90fea3c0&scoped=true"
import script from "./gift-present.vue?vue&type=script&lang=js"
export * from "./gift-present.vue?vue&type=script&lang=js"
import style0 from "./gift-present.vue?vue&type=style&index=0&id=90fea3c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fea3c0",
  null
  
)

export default component.exports